/*
 * Auth screens.
 *
 * NO HEIGHT TOKENS HERE. Input and Button both used to pin controlHeight and
 * controlHeightLG to 60, which is where the 60px-tall Login button came from —
 * a component-level token beats the global one, so the panel-wide 40px in
 * theme/controlTokens.js could not reach it. The inputs beside it still
 * measured 40 only because a CSS rule in index.css overrode the token, which
 * is why the form looked mismatched rather than uniformly oversized.
 *
 * Colours and spacing belong here; sizing belongs to controlTokens.js, in one
 * place, for the whole panel.
 */
export const authLightTheme = {
  Card: {
    borderRadius: 0,
    borderRadiusLG: 0,
    paddingLG: 40,
    paddingMD: 30,
    paddingXS: 20,
  },
  Layout: {
    bodyBg: '#E9E9E9',
  },
  Input: {
  },
  Button: {
  },
  Form: {},
}

export const authDarkTheme = {
  Card: {
    borderRadius: 0,
    borderRadiusLG: 0,
    paddingLG: 40,
    paddingMD: 30,
    paddingXS: 20,
    colorBgContainer: '#324A68',
    colorBorderSecondary: '#324A68',
  },
  Layout: {
    bodyBg: '#071026',
  },
  Input: {
    colorBgContainer: '#324A68',
    colorTextPlaceholder: '#BFBEBD',
    colorBorder: '#8F92A1',
    colorText: '#fff',
    colorIcon: '#8F92A1',
  },
  Button: {
    colorBgContainer: '#324A68',
    defaultBorderColor: '#DCDCDC',
    defaultColor: '#DCDCDC',
  },
  Form: {
    labelColor: '#CBCBCB',
  },
  Typography: {
    colorTextHeading: '#fff',
    colorTextDescription: '#CBCBCB',
    colorText: '#fff',
  },
  Modal: {
    contentBg: '#131B2F',
  },
}
